<template>
    <el-container>
        <el-container>
            <el-header>
                <el-row :gutter="20">
                    <el-form :inline="true" :model="fromModule" ref="fromModule" class="demo-form-inline">
                        <el-col :span="20">
                            <el-form-item>
                                <td-button :permissions="moduleAdd" type="button" @click.native="btnAddModule">{{ $t('common.ADD_MODULE') }}</td-button>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </el-row>
            </el-header>
            <el-aside width="265px">
                <div :style="'height:' + menuHeight + 'px'">
                    <td-permission :permissions="moduleView" :height="menuHeight">
                        <div slot="havePermission">
                            <el-menu @mouseenter.native="showDelBtnFun()" @mouseleave.native="showDelBtnFun()" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
                                <div v-for="(mod, index) in moudleData" :key="index">
                                    <el-row>
                                        <el-col :span="18">
                                            <el-menu-item class="extend-menu" :index="index" @click="queryByModule(mod.sId)" @dblclick.native="editModule(mod)">
                                                <i class="el-icon-menu"></i>
                                                <span slot="title">{{ mod.sModuleName }}</span>
                                            </el-menu-item></el-col
                                        >
                                        <el-col :span="3" style="padding:14px;">
                                            <td-button
                                                :permissions="moduleDel"
                                                class="extend-del-btn"
                                                v-if="showDelBtn"
                                                type="text"
                                                size="mini"
                                                icon="el-icon-delete"
                                                @click="() => removeModule(mod.sId)"
                                            >
                                            </td-button>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-menu>
                        </div>
                    </td-permission>
                </div>
            </el-aside>
        </el-container>
        <el-container>
            <el-header>
                <el-form :inline="true" :model="fromExtend" ref="fromExtend" class="demo-form-inline">
                    <el-row :gutter="20">
                        <td-permission :roles="roles" style="float:right;">
                            <div slot="havePermission">
                                <el-form-item :label="$t('common.CURSYS')">
                                    <td-select
                                        v-model="sysFlg"
                                        :placeholder="$t('common.PLEASE_SELECT')"
                                        @change="queryPageBySys()"
                                        :options="this.sysAndFlgList"
                                        keys="sSysFlg"
                                        text="sName"
                                        :clearable="false"
                                    >
                                    </td-select>
                                </el-form-item>
                            </div>
                        </td-permission>
                        <td-permission :permissions="permissionsView">
                            <div slot="havePermission">
                                <el-form-item :label="$t('common.EXTENDNAME')">
                                    <td-input placeholder="common.PLEASE_SELECT" v-model="fromExtend.sName"></td-input>
                                </el-form-item>
                            </div>
                        </td-permission>
                        <el-form-item>
                            <td-button type="primary" :permissions="permissionsView" :loading="loading" @click.native="queryPageList()">{{ $t('common.QUERY') }}</td-button>
                            <td-button type="button" :permissions="permissionsAdd" @click.native="btnAddExtend">{{ $t('common.ADD_EXTEND') }}</td-button>
                        </el-form-item>
                    </el-row>
                </el-form>
            </el-header>
            <el-main>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <!-- 加载表格 -->
                        <td-table
                            :columns="columns"
                            :permissions="permissionsView"
                            :dataSource="tableData"
                            :pageSize="pageSize"
                            :currentPage="currentPage"
                            :total="total"
                            :hasMutiSelect="false"
                            :hasLoading="loading"
                            @handleSizeChange="handleSizeChange"
                            @currentChange="currentChange"
                            rowKey="sId"
                        ></td-table>
                    </el-col>
                </el-row>
                <!-- 加载扩展信息dialog -->
                <dialog-ExtendInfo
                    v-if="dialogExtendVisible"
                    :isAddData="isAddData"
                    :dialogExtendVisible="dialogExtendVisible"
                    :curModule="this.fromExtend.sModuleId"
                    :moudleData="moudleData"
                    :sysFlg="this.sysFlg"
                    :maxExtendOrder="maxExtendOrder"
                    :editItem="editItem"
                    :title="title"
                    ref="addOrModifyInfo"
                    @extendDialogClose="extendDialogClose"
                    @submit="submit"
                ></dialog-ExtendInfo>
                <!-- 加载模块dialog -->
                <dialog-ModuleInfo
                    v-if="dialogModuleVisible"
                    :isAddModule="isAddModule"
                    :dialogModuleVisible="dialogModuleVisible"
                    :sysFlg="this.sysFlg"
                    :maxModuleOrder="maxModuleOrder"
                    :moduleItem="moduleItem"
                    :title="title"
                    ref="addOrModifyInfo"
                    @refreshModule="refreshModule"
                    @moduleDialogClose="moduleDialogClose"
                    @submit="submit"
                ></dialog-ModuleInfo>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import dialogExtendInfo from './components/dialogExtendInfo.vue';
import dialogModuleInfo from './components/dialogModuleInfo.vue';
import resourceApi from './assets/api.js';
export default {
    // 初始化渲染
    components: {
        'dialog-ExtendInfo': dialogExtendInfo,
        'dialog-ModuleInfo': dialogModuleInfo
    },
    created() {
        if (this.$common.systemInfo.systemId) {
            this.sysFlg = this.$common.systemInfo.systemId;
        } else {
            this.sysFlg = 'PG';
        }
        this.refreshModule();
        let param = {};
        resourceApi.getSysList(JSON.stringify(param), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('sys/getSysList', response.data.statusMessage);
            }
            this.sysList = response.data.content;
            this.sysAndFlgList = [];
            for (let index = 0; index < this.sysList.length; index++) {
                let element = this.sysList[index];
                this.sysAndFlgList.push({ sName: element.sName + '：' + element.sSysFlg, sSysFlg: element.sSysFlg });
            }
        });
        let content = {
            sSysFlg: this.sysFlg
        };
        let data = [];
        resourceApi.listModuleInfos(JSON.stringify(content), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('extend/getModuleInfos', response.data.statusMessage);
                return;
            }
            data = response.data.content;
            this.moudleData = data;
        });
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.queryPageList(); // 进行页面初始化数据的加载
        let obj = this;
        window.onresize = function windowResize() {
            obj.menuHeight = window.innerHeight - 140;
        };
        obj.menuHeight = window.innerHeight - 140;
    },

    // 定义数据
    data() {
        return {
            moudleData: [],
            fromExtend: {
                sName: '',
                sModuleId: ''
            },
            menuHeight: window.innerHeight - 140,
            permissionsAdd: ['extendInfo:add'],
            permissionsEdit: ['extendInfo:edit'],
            permissionsView: ['extendInfo:view'],
            permissionsDel: ['extendInfo:del'],
            moduleAdd: ['extendMod:add'],
            moduleEdit: ['extendMod:edit'],
            moduleView: ['extendMod:view'],
            moduleDel: ['extendMod:del'],
            roles: ['admin'],
            sysFlg: '',
            sysList: [],
            sysAndFlgList: [],
            editItem: '',
            moduleItem: {
                sId: '',
                sName: '',
                iOrder: ''
            },
            showDelBtn: true,
            dialogExtendVisible: false,
            dialogModuleVisible: false,
            maxExtendOrder: 1,
            maxModuleOrder: 1,
            tableData: [],
            isAddData: true, // 是否为添加数据
            isAddModule: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            columns: [
                {
                    prop: 'sName',
                    label: this.$t('common.EXTENDNAME'),
                    showOverflowTooltip: true
                },
                {
                    prop: 'sExtendType',
                    label: this.$t('common.EXTENDTYPE'),
                    render: (createElement, params) => {
                        let res = '';
                        if (params.row.sExtendType === 'input') {
                            res = this.$t('common.INPUT');
                        } else if (params.row.sExtendType === 'combobox') {
                            res = this.$t('common.COMBOBOX');
                        } else if (params.row.sExtendType === 'checkbox') {
                            res = this.$t('common.CHECKBOX');
                        } else if (params.row.sExtendType === 'checkboxgroup') {
                            res = this.$t('common.CHECKBOXGROUP');
                        } else if (params.row.sExtendType === 'radio') {
                            res = this.$t('common.RADIO');
                        } else if (params.row.sExtendType === 'date') {
                            res = this.$t('common.DATE');
                        }
                        return createElement('div', res);
                    }
                },
                {
                    prop: 'sParam',
                    label: this.$t('common.EXTENDDATA'),
                    render: (createElement, params) => {
                        let res = params.row.sParam;
                        if (params.row.sExtendType === 'input') {
                            if (params.row.sParam === 'input') {
                                res = this.$t('common.INPUT');
                            } else if (params.row.sParam === 'textarea') {
                                res = this.$t('common.TEXTAREA');
                            } else if (params.row.sParam === 'password') {
                                res = this.$t('common.PASSWORD_INPUT');
                            }
                        }
                        return createElement(
                            'div',
                            {
                                class: 'cell el-tooltip',
                                style: 'padding-left: 0'
                            },
                            res
                        );
                    },
                    showOverflowTooltip: true
                },
                {
                    prop: 'iOrder',
                    label: this.$t('common.ORDER')
                },
                /* 是否必填 */
                {
                    prop: 'iOrder',
                    label: this.$t('common.REQUIRED_VERIFICATION'),
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('span', params.row.iRequired == 0 ? this.$t('common.NOT') : this.$t('common.YES'));
                    }
                },
                /* 校验规则 */
                {
                    prop: 'sCheckRule',
                    tableWidth: '300',
                    label: this.$t('common.CHECK_RULE'),
                    showOverflowTooltip: true
                },
                /* 校验提示 */
                {
                    prop: 'sCheckTips',
                    tableWidth: '300',
                    label: this.$t('common.CHECK_RULE_TIPS'),
                    showOverflowTooltip: true
                },
                // {
                //     prop: 'sSysFlg',
                //     label: this.$t('common.SYSFLG')
                // },
                {
                    prop: '',
                    label: this.$t('common.OPERATE'),
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnEdit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnDelete(params.row.sId);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        // 根据mq的id显示对应的类型名称
        formatterType(row) {
            switch (row.iType) {
                case 0:
                    return this.$t('common.RABBITMQ');
                default:
                    return this.$t('common.UNKNOW_TYPE');
            }
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.submit();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.submit();
        },
        // 获取当前页
        queryByModule(moduleId) {
            this.fromExtend.sModuleId = moduleId;
            this.queryPageList();
        },
        queryPageList() {
            this.currentPage = 1;
            this.btnQuery();
        },
        queryPageBySys() {
            this.currentPage = 1;
            this.fromExtend.sModuleId = '';
            if (this.sysFlg !== 'nextPageValue' && this.sysFlg !== 'lastPageValue') {
                this.btnQuery();
            }
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            let param = {
                sName: this.fromExtend.sName,
                sModuleId: this.fromExtend.sModuleId,
                sSysFlg: this.sysFlg,
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };
            resourceApi.listExtendInfos(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extend/getExtendInfo', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });

            let content = {
                sSysFlg: this.sysFlg
            };
            let data = [];
            resourceApi.listModuleInfos(JSON.stringify(content), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extend/getModuleInfos', response.data.statusMessage);
                    return;
                }
                data = response.data.content;
                this.moudleData = data;
            });
        },
        // 添加
        btnAddExtend() {
            this.title = this.$t('common.ADD') + this.$t('common.EXTEND'); // 标题
            this.isAddData = true;

            let param = {
                sModuleId: this.fromExtend.sModuleId,
                sSysFlg: this.sysFlg
            };
            resourceApi.getMaxExtendOrder(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extend/getMaxExtendOrder', response.data.statusMessage);
                    return;
                }
                let data = response.data.content;
                this.maxExtendOrder = data[0].iOrder + 1;
                this.dialogExtendVisible = true;
            });
        },
        // 添加
        btnAddModule() {
            this.title = this.$t('common.ADD') + this.$t('common.MODULE'); // 标题
            this.isAddModule = true;

            let param = {
                sSysFlg: this.sysFlg
            };
            resourceApi.getMaxModuleOrder(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extend/getMaxModuleOrder', response.data.statusMessage);
                    return;
                }
                let data = response.data.content;
                this.maxModuleOrder = data[0].iOrder + 1;
                this.dialogModuleVisible = true;
            });
        },
        // 编辑
        btnEdit(row) {
            this.editItem = row;
            this.title = this.$t('common.EDIT') + this.$t('common.EXTEND');
            this.isAddData = false;
            this.dialogExtendVisible = true;
        },
        // 编辑模块
        editModule(item) {
            this.moduleItem = item;
            this.title = this.$t('common.EDIT') + this.$t('common.MODULE');
            this.isAddModule = false;
            this.dialogModuleVisible = true;
        },
        // 编辑模块
        removeModule(sId) {
            this.$confirm(this.$t('common.DELETE_MODULE_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = { sId: sId };
                    resourceApi.deleteModuleInfo(param, response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message.error({ showClose: true, message: response.data.message });
                            this.$log.error('extend/deleteModuleInfo', response.data.message);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.fromExtend.sModuleId = '';
                        this.refreshPage();
                    });
                })
                .catch(() => {});
        },
        // 删除接口
        btnDelete(sId) {
            this.$confirm(this.$t('common.DELETE_EXTEND_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = { sId: sId };
                    resourceApi.deleteExtendInfo(param, response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.message, type: 'error' });
                            this.$log.error('extend/deleteExtendInfo', response.data.message);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.refreshPage();
                    });
                })
                .catch(() => {
                    // this.$message.info(this.$t('common.ADD_FAIL'))
                    // this.$log.error('extendInfo/btnDelete---- Fail')
                });
        },
        // 组件关闭需要调用的方法
        submit() {
            this.btnQuery();
        },
        // 关闭页面
        extendDialogClose() {
            this.dialogExtendVisible = false;
        },
        // 关闭页面
        moduleDialogClose() {
            this.dialogModuleVisible = false;
        },

        // 刷新模块
        refreshModule() {
            let content = {
                sSysFlg: this.sysFlg
            };
            let data = [];
            resourceApi.listModuleInfos(JSON.stringify(content), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extend/getModuleInfos', response.data.statusMessage);
                    return;
                }
                data = response.data.content;
                this.moudleData = data;
            });
        },
        showDelBtnFun() {
            // this.showDelBtn = !this.showDelBtn
        },
        // 刷新模块
        refreshPage() {
            this.refreshModule();
            this.queryPageList();
        }
    }
};
</script>
